
import React, { PropTypes } from 'react';
import classnames from 'classnames';

import './style.scss';

const EmptyArticle = props => {
  const className = classnames('article-empty', {
    'is-featured': props.isFeatured,
    'is-darker': props.isDarker
  });

  return (
    <div className={className}>
      <div className="image"></div>

      <div className="inner">
        <div className="preview">
          <div className="text"></div>
        </div>
      </div>
    </div>
  );
};

EmptyArticle.propTypes = {
  isFeatured: PropTypes.bool,
  isDarker: PropTypes.bool
};

export default EmptyArticle;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/EmptyArticle/index.js
 **/